const blank = "https://www.booksie.com/files/profiles/22/mr-anonymous_230x230.png?0000-00-00%2000:00:00"

export const prizes = [
    {
        title: "Raspberry Pi (Mini PC)",
        photo: "https://cdn-shop.adafruit.com/970x728/2258-01.jpg",
    },
    {
        title: "Anker Bluetooth Speaker",
        photo: "https://m.media-amazon.com/images/I/614l20nEhmL.__AC_SX300_SY300_QL70_FMwebp_.jpg",
    },
    // {
    //     title: "Tech Bag",
    //     photo: "https://m.media-amazon.com/images/I/81OGglbW0DL._AC_SY450_.jpg",
    // },
    {
        title: "Amazon Alexa / Echo Dot",
        photo: "https://m.media-amazon.com/images/I/710exCeNPJL._AC_SY355_.jpg",
    },
    {
        title: "Gaming Mouse and Keyboard",
        photo: "https://m.media-amazon.com/images/I/71AR+xtHK7L._AC_SX569_.jpg",
    },
    {
        title: "STEAM Gaming Gift Card",
        photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-3mrll8inNYxpTqtbHlJymURw_978a_VRRQ&s",
    },
    {
        title: "JBL Noise-Canceling Headphones",
        photo: "https://bfasset.costco-static.com/U447IH35/as/nm7cc7vnmqws3tq5vbjmpphp/4000280025-847__1?auto=webp&amp;format=jpg&width=150&height=150&fit=bounds&canvas=150,150",
    }
]